import React from 'react';
import { Card, CardContent } from '../components/ui/card';
import { Button } from '../components/ui/button';
import { CheckCircle2, Clock } from 'lucide-react';
import { courses } from '../data/mock';
import { Link } from 'react-router-dom';

const CoursesPage = () => {
  return (
    <div className="min-h-screen pt-20">
      {/* Hero */}
      <section className="py-20 bg-gradient-to-br from-blue-600 to-blue-800 text-white">
        <div className="container mx-auto px-4 text-center">
          <h1 className="text-5xl font-bold mb-6">Onze Cursussen</h1>
          <p className="text-xl text-blue-100 max-w-3xl mx-auto">
            Kies de rijcursus die het beste bij jou past. Van standaard tot intensief, wij hebben voor elk wat wils.
          </p>
        </div>
      </section>

      {/* Courses Grid */}
      <section className="py-20 bg-gray-50">
        <div className="container mx-auto px-4">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-8">
            {courses.map((course) => (
              <Card key={course.id} className="border-none shadow-xl hover:shadow-2xl transition-shadow duration-300">
                <CardContent className="p-8">
                  <div className="flex items-start justify-between mb-4">
                    <h3 className="text-2xl font-bold text-gray-900">{course.name}</h3>
                    <div className="flex items-center text-blue-600 bg-blue-50 px-3 py-1 rounded-full">
                      <Clock className="w-4 h-4 mr-1" />
                      <span className="text-sm font-medium">{course.duration}</span>
                    </div>
                  </div>
                  <p className="text-gray-600 mb-6 leading-relaxed">{course.description}</p>
                  
                  <div className="space-y-3 mb-6">
                    <h4 className="font-semibold text-gray-900">Wat is inbegrepen:</h4>
                    {course.includes.map((item, index) => (
                      <div key={index} className="flex items-start space-x-2">
                        <CheckCircle2 className="w-5 h-5 text-blue-600 flex-shrink-0 mt-0.5" />
                        <span className="text-gray-700">{item}</span>
                      </div>
                    ))}
                  </div>

                  <Link to="/contact">
                    <Button className="w-full bg-blue-600 hover:bg-blue-700">
                      Aanmelden voor deze cursus
                    </Button>
                  </Link>
                </CardContent>
              </Card>
            ))}
          </div>
        </div>
      </section>

      {/* Additional Info */}
      <section className="py-20 bg-white">
        <div className="container mx-auto px-4">
          <div className="max-w-4xl mx-auto">
            <h2 className="text-3xl font-bold text-gray-900 mb-8 text-center">Hoe werkt het?</h2>
            <div className="grid md:grid-cols-3 gap-8">
              <div className="text-center">
                <div className="w-16 h-16 bg-blue-100 rounded-full flex items-center justify-center mx-auto mb-4 text-2xl font-bold text-blue-600">
                  1
                </div>
                <h3 className="text-xl font-semibold text-gray-900 mb-2">Kies je cursus</h3>
                <p className="text-gray-600">
                  Selecteer de rijcursus die het beste bij jouw situatie past.
                </p>
              </div>
              <div className="text-center">
                <div className="w-16 h-16 bg-blue-100 rounded-full flex items-center justify-center mx-auto mb-4 text-2xl font-bold text-blue-600">
                  2
                </div>
                <h3 className="text-xl font-semibold text-gray-900 mb-2">Plan je proefles</h3>
                <p className="text-gray-600">
                  Neem contact op en plan je gratis proefles in op een moment dat jou uitkomt.
                </p>
              </div>
              <div className="text-center">
                <div className="w-16 h-16 bg-blue-100 rounded-full flex items-center justify-center mx-auto mb-4 text-2xl font-bold text-blue-600">
                  3
                </div>
                <h3 className="text-xl font-semibold text-gray-900 mb-2">Start met lessen</h3>
                <p className="text-gray-600">
                  Begin met je rijlessen en werk samen met je instructeur aan je rijbewijs.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* CTA */}
      <section className="py-20 bg-blue-600 text-white">
        <div className="container mx-auto px-4 text-center">
          <h2 className="text-4xl font-bold mb-6">Twijfel je nog welke cursus bij je past?</h2>
          <p className="text-xl mb-8 text-blue-100 max-w-2xl mx-auto">
            Neem vrijblijvend contact met ons op. Wij helpen je graag bij het maken van de juiste keuze.
          </p>
          <Link to="/contact">
            <Button size="lg" className="bg-white text-blue-600 hover:bg-gray-100 text-lg px-8 py-6">
              Neem Contact Op
            </Button>
          </Link>
        </div>
      </section>
    </div>
  );
};

export default CoursesPage;